import {css} from 'lit';
export const styles = css`:host {
  --height: auto;
  --date-widget-bg: var(--light-secondary);
  --date-widget-text: var(--dark-text);
  --bg: var(--contrast-light);
  --bg-hover: var(--gray-200);
  --bg-active: var(--gray-300);
  --color: var(--dark-text);

  display: block;
}

a {
  display: flex;
  color: var(--color);
  border-radius: var(--border-radius);
  background-color: var(--bg);
}

@media (hover: hover) {
    a:hover {
      background-color: var(--bg-hover);
      color: var(--color);
    }
  }

a:active {
    background-color: var(--bg-active);
    color: var(--color);
  }

xs-card-date-widget {
  --contrast-light: var(--date-widget-bg);
  --dark-text-secondary: var(--date-widget-text);
  --font-size-lg: 30px;
  --font-size-sm: 16px;
  --text-transform: capitalize;

  height: var(--height);
  width: 64px;
  border-radius: var(--border-radius) 0 0 var(--border-radius);
}

section {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: var(--height);
  padding: 16px;
  min-width: 1px;
}

::slotted(*) {
  margin: 0;
  font-size: var(--font-size-lg);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
}

footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

xs-origin {
  font-size: var(--font-size-sm);
}

ef-label {
  --background-primary: var(--contrast-dark);
  --text-primary: var(--contrast-light);
}

time {
  font-size: var(--font-size-sm);
  color: var(--dark-text-secondary);
  line-height: 1.2;
}

time span:last-child {
    border-left: 1px solid var(--gray-400);
    padding-left: 4px;
  }

/* TO DO: check if style written here is going to be mobile-first default */

@media (max-width: 400px) {
  :host {
    --height: auto;
  }

  footer {
    flex-direction: column;
    align-items: flex-start;
  }

  xs-origin {
    margin-bottom: 6px;
  }

  ef-label {
    --font-size-primary: 12px;
  }
}
`;
export default styles;
